// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { Alert } from '@/components/ui/feedback';
import { IconMail, IconArrowLeft, IconKey, IconCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ForgotClassicMinimal() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <AuthLayoutWrapper variant="simple">
        <Stack gap="lg" align="center">
          <Center
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: 'var(--mantine-color-green-light)',
            }}
          >
            <IconCheck size={32} color="var(--mantine-color-green-6)" />
          </Center>

          <Stack align="center" gap="xs">
            <Title order={2} ta="center">Check your email</Title>
            <Text c="dimmed" ta="center" maw={300}>
              We've sent a password reset link to <strong>{email}</strong>
            </Text>
          </Stack>

          <Alert color="blue" variant="light" w="100%">
            <Text size="sm">
              Didn't receive the email? Check your spam folder or{' '}
              <Anchor onClick={() => setSubmitted(false)}>try again</Anchor>
            </Text>
          </Alert>

          <Button
            component={Link}
            to="/demo/auth-pages/login/simple"
            variant="subtle"
            leftSection={<IconArrowLeft size={16} />}
          >
            Back to login
          </Button>
        </Stack>
      </AuthLayoutWrapper>
    );
  }

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/forgot-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                backgroundColor: 'var(--mantine-color-orange-light)',
              }}
            >
              <IconKey size={28} color="var(--mantine-color-orange-6)" />
            </Center>
            <Title order={2} ta="center">Forgot password?</Title>
            <Text c="dimmed" size="sm" ta="center" maw={300}>
              No worries, we'll send you reset instructions.
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="Enter your email"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Button type="submit" fullWidth>
              Send reset link
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/demo/auth-pages/login/simple" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to login
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
